"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGIONS_BY_KEY = exports.REGIONS = void 0;
exports.REGIONS = [
    {
        key: "SOUTH_WEST",
        name: "South West",
        places: [
            "Avon",
            "Bath",
            "Bournemouth",
            "Bristol",
            "Cornwall",
            "Devon",
            "Dorset",
            "Gloucestershire",
            "Poole",
            "Somerset",
            "Swindon",
            "Wiltshire",
            "Christchurch",
            "North East Somerset",
            "Torbay",
            "North Somerset",
            "Plymouth",
            "South Gloucestershire",
        ],
    },
    {
        key: "SOUTH_EAST",
        name: "South East",
        places: [
            "Berkshire",
            "Brighton",
            "Brighton and Hove",
            "Hove",
            "Buckinghamshire",
            "East Sussex",
            "Hampshire",
            "Isle of Wight",
            "Kent",
            "Medway",
            "Milton Keynes",
            "Oxfordshire",
            "Portsmouth",
            "Reading",
            "Slough",
            "Southampton",
            "Surrey",
            "Sussex",
            "West Sussex",
            "Windsor",
            "Wokingham",
            "Bracknell Forest",
            "Maidenhead",
            "West Berkshire",
            "Slough",
        ],
    },
    {
        key: "LONDON",
        name: "London",
        places: [
            "Barking",
            "Barking and Dagenham",
            "Dagenham",
            "Barnet",
            "Bexley",
            "Brent",
            "Bromley",
            "Camden",
            "Chelsea",
            "Croydon",
            "Ealing",
            "Enfield",
            "Fulham",
            "Greenwich",
            "Hackney",
            "Hammersmith",
            "Hammersmith and Fulham",
            "Haringey",
            "Harrow",
            "Havering",
            "Hillingdon",
            "Hounslow",
            "Islington",
            "Kensington",
            "Kensington and Chelsea",
            "Kingston",
            "Lambeth",
            "Lewisham",
            "London",
            "Merton",
            "Newham",
            "Redbridge",
            "Richmond",
            "Southwark",
            "Sutton",
            "Tower Hamlets",
            "Waltham Forest",
            "Wandsworth",
            "Westminster",
            "Greater London",
            "Middlesex",
        ],
    },
    {
        key: "EAST_OF_ENGLAND",
        name: "East of England",
        places: [
            "Bedford",
            "Bedfordshire",
            "Cambridgeshire",
            "Central Bedfordshire",
            "Essex",
            "Hertfordshire",
            "Huntingdon",
            "Huntingdonshire",
            "Luton",
            "Norfolk",
            "Peterborough",
            "Suffolk",
            "East Suffolk",
            "Isle of Ely",
            "West Suffolk",
            "Southend-on-Sea",
            "Southend",
            "Thurrock",
        ],
    },
    {
        key: "WEST_MIDLANDS",
        name: "West Midlands",
        places: [
            "Birmingham",
            "Coventry",
            "Dudley",
            "Hereford and Worcester",
            "Hereford",
            "Hereford",
            "Sandwell",
            "Solihull",
            "Staffordshire",
            "Stoke-on-Trent",
            "Telford and Wrekin",
            "Telford",
            "Wrekin",
            "Walsall",
            "Warwickshire",
            "Wolverhampton",
            "Worcestershire",
            "Birmingham",
            "Shropshire",
        ],
    },
    {
        key: "EAST_MIDLANDS",
        name: "East Midlands",
        places: [
            "Derby",
            "Derbyshire",
            "Leicester",
            "Leicestershire",
            "Lincolnshire",
            "Northamptonshire",
            "Nottingham",
            "Nottinghamshire",
            "Rutland",
            "West Northamptonshire",
        ],
    },
    {
        key: "NORTH_WEST",
        name: "North West",
        places: [
            "Blackburn",
            "Blackpool",
            "Bolton",
            "Bury",
            "Cheshire",
            "Cheshire East",
            "Cheshire West",
            "Cheshire West and Chester",
            "Chester",
            "Cumbria",
            "Greater Manchester",
            "Lancashire",
            "Liverpool",
            "Manchester",
            "Merseyside",
            "Oldham",
            "Rochdale",
            "Salford",
            "Stockport",
            "Tameside",
            "Trafford",
            "Warrington",
            "Wigan",
            "Wirral",
            "Cumberland",
            "Darwen",
            "Halton",
            "Sefton",
            "St Helens",
        ],
    },
    {
        key: "YORKSHIRE_AND_HUMBER",
        name: "Yorkshire and the Humber",
        places: [
            "Barnsley",
            "Doncaster",
            "East Riding of Yorkshire",
            "Humberside",
            "Kirklees",
            "Leeds",
            "North East Lincolnshire",
            "North Lincolnshire",
            "Lincolnshire",
            "North Yorkshire",
            "Rotherham",
            "Sheffield",
            "South Yorkshire",
            "Wakefield",
            "York",
            "Yorkshire",
            "Bradford",
            "Calderdale",
            "Kingston upon Hull",
            "Hull",
            "North Humberside",
            "South Humberside",
        ],
    },
    {
        key: "NORTH_EAST",
        name: "North East",
        places: [
            "Cleveland",
            "Darlington",
            "Durham",
            "Gateshead",
            "Hartlepool",
            "Middlesbrough",
            "Newcastle",
            "Northumberland",
            "Redcar and Cleveland",
            "Redcar",
            "Cleveland",
            "Stockton-on-Tees",
            "Sunderland",
            "Tyne and Wear",
            "County Durham",
            "South Tyneside",
            "North Tyneside",
        ],
    },
    {
        key: "WALES",
        name: "Wales",
        places: [
            "Anglesey",
            "Brecknockshire",
            "Caernarfonshire",
            "Cardiganshire",
            "Carmarthenshire",
            "Clwyd",
            "Denbighshire",
            "Dyfed",
            "Flintshire",
            "Glamorgan",
            "Gwent",
            "Gwynedd",
            "Merionethshire",
            "Mid Glamorgan",
            "Monmouthshire",
            "Montgomeryshire",
            "Pembrokeshire",
            "Powys",
            "Radnorshire",
            "South Glamorgan",
            "West Glamorgan",
            "Wrexham",
        ],
    },
    {
        key: "SCOTLAND",
        name: "Scotland",
        places: [
            "Scotland",
            "Aberdeen",
            "Aberdeenshire",
            "Angus",
            "Argyll",
            "Ayrshire",
            "Banffshire",
            "Berwickshire",
            "Bute",
            "Caithness",
            "Clackmannanshire",
            "Cromartyshire",
            "Dumfriesshire",
            "Dunbartonshire",
            "Dumbarton",
            "Dundee",
            "East Lothian",
            "Haddingtonshire",
            "Edinburgh",
            "Fife",
            "Glasgow",
            "Invernessshire",
            "Kincardineshire",
            "Kinrossshire",
            "Kirkcudbrightshire",
            "Lanarkshire",
            "Edinburgh",
            "Midlothian",
            "Moray",
            "Elginshire",
            "Nairnshire",
            "Orkney",
            "Peeblesshire",
            "Perthshire",
            "Renfrewshire",
            "Ross and Cromarty",
            "Rossshire",
            "Roxburghshire",
            "Selkirkshire",
            "Shetland",
            "Zetland",
            "Stirlingshire",
            "Sutherland",
            "West Lothian",
            "Wigtownshire",
        ],
    },
    {
        key: "NORTHERN_IRELAND_ANTRIM",
        name: "Antrim",
        places: ["Antrim"],
    },
    {
        key: "NORTHERN_IRELAND_DERRY",
        name: "Derry",
        places: ["Derry", "Londonderry"],
    },
    {
        key: "NORTHERN_IRELAND_ARMAGH",
        name: "Armagh",
        places: ["Armagh"],
    },
    {
        key: "NORTHERN_IRELAND_DOWN",
        name: "Down",
        places: ["Down"],
    },
    {
        key: "NORTHERN_IRELAND_TYRONE",
        name: "Tyrone",
        places: ["Tyrone"],
    },
    {
        key: "NORTHERN_IRELAND_FERMANAGH",
        name: "Fermanagh",
        places: ["Fermanagh"],
    },
    {
        key: "NORTHERN_IRELAND_BELFAST",
        name: "Belfast",
        places: ["Belfast"],
    },
];
exports.REGIONS_BY_KEY = Object.fromEntries(exports.REGIONS.map((region) => [region.key, region]));
